import axios from "axios";

const getCompatibilityManufacturerList = productCode => {
  const url = `/ignitionapi/ProductService/GetCompatibilityManufacturerList?productCode=${productCode}`;
  const config = {
    headers: { Pragma: "no-cache" }
  };

  return axios.get(url, config);
};

const getCompatibilityProducts = (productCode, manufacturerID) => {
  const url = `/ignitionapi/ProductService/GetCompatibilityProducts?productCode=${productCode}&manufacturerID=${manufacturerID}`;
  const config = {
    headers: { Pragma: "no-cache" }
  };

  return axios.get(url, config);
};

const isProductChiefMount = (brandDetails, isSkuPage) => {
  // checks url before continuing
  const isMount = isProductUrlMount();
  if (false === isMount || false === isSkuPage) {
    return false;
  }

  const chiefBrand = "BE7BB94D-EC9F-431E-8415-355799AFE8D0".toLowerCase();
  if (brandDetails) {
    return brandDetails.reduce((value, brand) => {
      // value has already been set dont change
      if (true === value) {
        return value;
      }

      const formattedBrandId = brand.Id.toLowerCase();
      if (formattedBrandId === chiefBrand) {
        value = true;
        return value;
      } else {
        return false;
      }
    }, false);
  }

  return false;
};

const isProductUrlMount = () => {
  const path = window.location.pathname.toLowerCase();
  const productMountsPath = "/products/mounts/";

  return path.includes(productMountsPath);
};

export default {
  getCompatibilityManufacturerList,
  getCompatibilityProducts,
  isProductChiefMount
};
